// Definición del cuestionario de calificación de leads (solo presentación).
// Los pesos y el cálculo del score viven en el backend
// (calendar-functions/utils/leadScoring.js) para que la vista de admin y el bot
// de WhatsApp den siempre el mismo resultado.
// Ver docs/journey-leads-y-seguimiento.md.

// Pregunta que rutea: define qué set de preguntas se muestra después.
export const PRODUCT_LINE_QUESTION = {
  id: 'productLine',
  label: '¿Qué tipo de solución integral necesita su negocio?',
  options: [
    { value: 'erp', label: 'Empresa — procesos, ventas y operación' },
    { value: 'restaurante', label: 'Restaurante — operación y servicio' },
  ],
};

const TIMELINE_QUESTION = {
  id: 'timeline',
  label: '¿Para cuándo lo necesita?',
  hint: 'Lo que más predice si cierra.',
  options: [
    { value: 'ya', label: 'Ya, es urgente' },
    { value: 'este_mes', label: 'Este mes' },
    { value: '1_3_meses', label: 'En 1-3 meses' },
    { value: 'explorando', label: 'Solo explorando' },
  ],
};

export const QUALIFICATION_QUESTIONS = {
  erp: [
    {
      id: 'employees',
      label: '¿Cuántos empleados son?',
      hint: 'Define si un desarrollo a la medida es viable.',
      options: [
        { value: '50_mas', label: '50 o más' },
        { value: '20_49', label: '20 a 49' },
        { value: '6_19', label: '6 a 19' },
        { value: '1_5', label: '1 a 5' },
      ],
    },
    {
      id: 'needs',
      label: '¿Qué necesita integrar?',
      multi: true,
      options: [
        { value: 'crm', label: 'CRM / ventas' },
        { value: 'pm', label: 'Proyectos (PM)' },
        { value: 'hr', label: 'Recursos humanos' },
        { value: 'facturacion', label: 'Facturación' },
        { value: 'inventario', label: 'Inventario' },
      ],
    },
    {
      id: 'currentSystem',
      label: '¿Qué usan hoy?',
      options: [
        { value: 'nada', label: 'Nada' },
        { value: 'excel_papel', label: 'Excel o papel' },
        { value: 'otro_sistema', label: 'Otro sistema' },
        { value: 'odoo', label: 'Odoo' },
      ],
    },
    TIMELINE_QUESTION,
  ],
  restaurante: [
    {
      id: 'locations',
      label: '¿Cuántas localidades?',
      options: [
        { value: '3_mas', label: '3 o más' },
        { value: '2', label: '2' },
        { value: '1', label: '1' },
      ],
    },
    {
      id: 'needs',
      label: '¿Qué necesita?',
      multi: true,
      options: [
        { value: 'pos', label: 'POS / Clover' },
        { value: 'menu', label: 'Menú digital' },
        { value: 'reservas', label: 'Reservas' },
        { value: 'delivery', label: 'Delivery' },
        { value: 'inventario', label: 'Inventario' },
      ],
    },
    {
      id: 'currentPos',
      label: '¿Qué POS usan hoy?',
      options: [
        { value: 'ninguno', label: 'Ninguno' },
        { value: 'clover', label: 'Clover' },
        { value: 'otro', label: 'Otro' },
      ],
    },
    TIMELINE_QUESTION,
  ],
};

export const getQuestionsForLine = (productLine) =>
  QUALIFICATION_QUESTIONS[String(productLine || '').trim().toLowerCase()] || [];

// El score lo calcula el backend; aquí solo se colorea el resultado.
export const getScoreBadge = (score) => {
  if (score >= 70) return 'bg-emerald-100 text-emerald-700';
  if (score >= 45) return 'bg-amber-100 text-amber-700';
  return 'bg-gray-100 text-gray-600';
};
